import clsx from "clsx";
import { useTranslation } from "react-i18next";
// 依需求先隱藏語系選擇（如需還原，取消下方 import 與 JSX 的註解）
// import LanguageSwitcher from "components/LanguageSwitcher";

interface RootLayoutProps {
  children: React.ReactNode;
  title: string;
}

const RootLayout = ({ children, title }: RootLayoutProps) => {
  const { t } = useTranslation("common");
  return (
    <div className="h-screen w-screen">
      <header
        className={clsx(
          "h-28 fixed right-0 left-0 z-10",
          "border-t-[5px] border-t-[#FF9966] border-b-[5px] border-b-[#FF6666]"
        )}
      >
        <img
          src="/img/rectangle-1.png"
          alt="header"
          className="w-full h-full"
        />
        {/* 語言切換：依需求先隱藏語系選擇（如需還原，取消此註解並恢復上方 import）
        <div className="absolute top-2 left-3 z-20">
          <LanguageSwitcher variant="header" align="left" />
        </div>
        */}
        <div
          className={clsx(
            "absolute bottom-3 right-5 max-w-[58%] px-3 py-1",
            "flex items-center justify-center text-center leading-tight",
            "bg-[#9F0050] text-white text-xs rounded-xl"
          )}
        >
          {t("brand.platform")}
        </div>
      </header>
      <main className="pt-28 min-h-[calc(100%-32px)]">
        <nav className="min-h-10 px-6 py-1.5 flex items-center bg-[#C83862] text-white text-2xl leading-tight">
          <span>{title}</span>
        </nav>
        <main>{children}</main>
      </main>
      <footer
        className={clsx(
          "h-8 sticky left-0 right-0 bottom-0",
          "flex items-center justify-center gap-1",
          "bg-[#FCE4EC] text-[#00000080] text-sm"
        )}
      >
        <span>{t("brand.copyright")}</span>
        <span aria-hidden="true">·</span>
        <span>{t("brand.poweredBy")}</span>
        <a
          href="https://www.mediconnect.tw/"
          target="_blank"
          rel="noopener noreferrer"
          className="underline hover:text-[#9F0050]"
        >
          {t("brand.company")}
        </a>
      </footer>
    </div>
  );
};

export default RootLayout;
